// src/pages7-recipie-ai/WelcomeOnboarding.js
import React, { useState } from "react";
import logo from "../images/recipeailogo.jpg";
import config from "../config.json";
import { FaArrowRight, FaUtensils, FaFire, FaMicrophone, FaSparkles } from "react-icons/fa";
import "./WelcomeOnboarding.css";

const FEATURES = [
  {
    icon: <FaUtensils size={22} className="text-warning" />,
    title: "Pantry to Plate",
    desc: "Turn what's in your fridge into chef-crafted recipes with zero food waste."
  },
  {
    icon: <FaFire size={22} className="text-danger" />,
    title: "Instant Calorie & Macro AI",
    desc: "Snap a photo of your meal to calculate exact calories, protein, carbs & fat."
  },
  {
    icon: <FaMicrophone size={20} className="text-success" />,
    title: "Hands-Free Voice Assistant",
    desc: "Speak your ingredients or cravings and let Gemini AI create your dish."
  }
];

const FLOATING_EMOJIS = [
  { emoji: "🥑", top: "12%", left: "8%", delay: "0s", duration: "4.5s" },
  { emoji: "🍅", top: "18%", right: "10%", delay: "0.8s", duration: "5.2s" },
  { emoji: "🥦", top: "38%", left: "6%", delay: "1.5s", duration: "4.8s" },
  { emoji: "🍳", top: "42%", right: "8%", delay: "0.4s", duration: "4.2s" },
  { emoji: "🌮", top: "68%", left: "12%", delay: "1.2s", duration: "5.5s" },
  { emoji: "🍲", top: "72%", right: "12%", delay: "1.9s", duration: "4.9s" },
  { emoji: "🍋", top: "86%", left: "22%", delay: "0.6s", duration: "5.1s" },
  { emoji: "🥕", top: "88%", right: "20%", delay: "1.4s", duration: "4.7s" },
];

const WelcomeOnboarding = ({ onContinue, onExplore }) => {
  return (
    <div className="welcome-screen-root">
      {/* Dynamic Animated Ambient Background Glows */}
      <div className="welcome-glow-orb glow-top-left"></div>
      <div className="welcome-glow-orb glow-bottom-right"></div>
      <div className="welcome-glow-orb glow-center"></div>

      {/* Floating Culinary Emojis */}
      <div className="welcome-floating-emojis-layer" aria-hidden="true">
        {FLOATING_EMOJIS.map((item, idx) => (
          <span
            key={idx}
            className="welcome-floating-emoji"
            style={{
              top: item.top,
              left: item.left,
              right: item.right,
              animationDelay: item.delay,
              animationDuration: item.duration,
            }}
          >
            {item.emoji}
          </span>
        ))}
      </div>

      {/* Main Glass Content Container */}
      <div className="welcome-content-container">
        {/* Top Chef Logo & Brand */}
        <div className="welcome-brand-header text-center">
          <div className="welcome-logo-halo mb-3">
            <img
              src={logo}
              alt="Recipe AI"
              className="welcome-app-logo"
            />
          </div>
          <div className="welcome-tag-pill mb-2">
            <span>✨ Powered by Advanced Gemini AI</span>
          </div>
          <h1 className="welcome-hero-title">
            Cook Smarter. <br />
            <span className="welcome-title-accent">Eat Healthier.</span>
          </h1>
          <p className="welcome-hero-subtitle">
            Your personal AI culinary assistant that transforms whatever you have at home into extraordinary meals with full nutrition tracking.
          </p>
        </div>

        {/* Feature Cards Showcase */}
        <div className="welcome-features-list">
          {FEATURES.map((feat, idx) => (
            <div key={idx} className="welcome-feature-card">
              <div className="welcome-feature-icon-wrap">
                {feat.icon}
              </div>
              <div className="welcome-feature-text">
                <h4 className="welcome-feature-heading">{feat.title}</h4>
                <p className="welcome-feature-desc">{feat.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Actions */}
        <div className="welcome-action-bottom">
          <button
            type="button"
            className="welcome-btn-primary"
            onClick={onContinue}
          >
            <span>Get Started</span>
            <FaArrowRight size={14} className="ms-2" />
          </button>

          {onExplore && (
            <button
              type="button"
              className="welcome-btn-secondary"
              onClick={onExplore}
            >
              Explore without sign-in &rarr;
            </button>
          )}

          <p className="welcome-privacy-note">
            By continuing, you agree to our Terms of Use & Privacy Policy.
          </p>
        </div>
      </div>
    </div>
  );
};

export default WelcomeOnboarding;
